export const projects = [
  {
    id: 'repertory',
    title: "Repertory",
    description: "",
    year: "",
    link: "/repertory",
    image: "Repertory.jpg"  // Add this - use your actual filename
  },
  {
    id: 'project-b',
    title: "Videos",
    description: "",
    year: "",
    link: "/project-b",
    image: "videos.png"  // Add this - use your actual filename
  },
  {
    id: 'teaching',
    title: "Teaching",
    description: "",
    year: "",
    link: "/teaching",
    image: "teaching.jpg"  // Add this - use your actual filename
  }
];